import React, { useCallback, useState } from 'react';
import debounce from 'lodash-es/debounce';
import { PropTypes } from 'prop-types';
import { Input, InputGroup, InputGroupText } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const DEBOUNCE_DELAY_MS = 500;

export default function DebouncedSearchInput({ onChange, placeholder, disabled }) {
  const [inputValue, setInputValue] = useState('');

  const debouncedChangeHandler = useCallback(
    debounce(value => onChange(value), DEBOUNCE_DELAY_MS),
    []
  );

  const handleInputChange = ({ target }) => {
    const { value: searchString } = target;
    setInputValue(searchString);
    debouncedChangeHandler(searchString);
  };

  return (
    <InputGroup className="search-input">
      <Input
        type="search"
        name="search"
        className="cancel-icon-search small-important"
        placeholder={placeholder}
        value={inputValue}
        onChange={handleInputChange}
        disabled={disabled}
      />
      <InputGroupText>
        <FontAwesomeIcon icon="search" className="small" />
      </InputGroupText>
    </InputGroup>
  );
}

DebouncedSearchInput.propTypes = {
  onChange: PropTypes.func.isRequired
};
